import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import { all, put, takeLatest } from 'redux-saga/effects';
import env from '../../config/env';
import * as service from '../../services/checkout.service';
import { PAYMENT_ACTIVATION_STATUS, USER_ROLES } from '../../utils/constants';
import { getHotelRequest, getUserRequest, setCurrentStep, setPaymentActivate } from '../slice';
import { SAVE_BANK_DETAILS_REQUEST, SAVE_BUSINESS_DETAILS_REQUEST, SAVE_STAKEHOLDER_DETAILS_REQUEST } from '../types';

function* saveBusinessDetailsSaga(action) {
    try {
        const { step, payload } = action.payload;
        yield service.saveBusinessDetails(payload);
        toast.success('Business details saved successfully');
        yield put(setCurrentStep(step));

        if (localStorage.getItem('trackerSecret')) {
            const trackerSecret = CryptoJS.AES.encrypt(JSON.stringify({
                hotelId: payload.hotelId,
                status: PAYMENT_ACTIVATION_STATUS.stakeholder
            }), env.cryptoSecret).toString();
            localStorage.setItem('trackerSecret', trackerSecret);
        }
    } catch (error) {
        console.error('Failed to add business details', error);
        toast.error(`Failed to add business details ${error.message}`);
    }
}

function* saveStakeholderDetailsSaga(action) {
    try {
        const { step, payload } = action.payload;
        yield service.saveStakeholderDetails(payload);
        toast.success('Stakeholder details saved successfully');
        yield put(setCurrentStep(step));

        if (localStorage.getItem('trackerSecret')) {
            const trackerSecret = CryptoJS.AES.encrypt(JSON.stringify({
                hotelId: payload.hotelId,
                status: PAYMENT_ACTIVATION_STATUS.bank
            }), env.cryptoSecret).toString();
            localStorage.setItem('trackerSecret', trackerSecret);
        }
    } catch (error) {
        console.error('Failed to add stakeholder details', error);
        toast.error(`Failed to add stakeholder details ${error.message}`);
    }
}

function* saveBankDetailsSaga(action) {
    try {
        const { payload, navigate } = action.payload;
        yield service.saveBankDetails(payload);
        toast.success('Account activated successfully');

        yield put(getUserRequest());
        yield put(setPaymentActivate({ show: false, hotelId: null }));

        if (localStorage.getItem('data')) {
            const viewData = JSON.parse(
                CryptoJS.AES.decrypt(localStorage.getItem('data'), env.cryptoSecret).toString(CryptoJS.enc.Utf8)
            );
            if (viewData.role === USER_ROLES.foodCourtShopOwner) {
                navigate('/dashboard');
            } else {
                yield put(getHotelRequest());
            }
        }

        localStorage.removeItem('trackerSecret');
        yield put(setCurrentStep(1));
    } catch (error) {
        console.error('Failed to activate details', error);
        toast.error(`Failed to activate details ${error.message}`);
    }
}

export default function* paymentActivationSaga() {
    yield all([
        takeLatest(SAVE_BUSINESS_DETAILS_REQUEST, saveBusinessDetailsSaga),
        takeLatest(SAVE_STAKEHOLDER_DETAILS_REQUEST, saveStakeholderDetailsSaga),
        takeLatest(SAVE_BANK_DETAILS_REQUEST, saveBankDetailsSaga)
    ]);
}
